export default __webpack_public_path__ + "static/media/lips.0b808d21.jpeg";